import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarRangeComponent.css';

const CalendarRangeComponent = ({ setDateValue }) => {
  const [dateRange, setDateRange] = useState(null);

  const handleDateChange = (value) => {
    setDateRange(value);
    setDateValue(value);
  };

  return (
    <div className="calendar-container">
      <Calendar 
        onChange={handleDateChange}
        selectRange={true}
        value={dateRange}
        locale="fr-FR"
        minDate={new Date()}
      />
    </div>
  );
};

export default CalendarRangeComponent;
